module.exports = require("argon2");